<template>
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 38C6.44772 38 6 37.5523 6 37C6 36.4477 6.44771 36 7 36L14.1 36C14.5633 33.7178 16.581 32 19 32C21.419 32 23.4367 33.7178 23.9 36L41 36C41.5523 36 42 36.4477 42 
                37C42 37.5523 41.5523 38 41 38L23.9 38C23.4367 40.2822 21.419 42 19 42C16.581 42 14.5633 40.2822 14.1 38L7 38ZM16 36.9983C16 36.9989 16 36.9994 16 37C16 38.6569 17.3431 
                40 19 40C20.6569 40 22 38.6569 22 37C22 35.3431 20.6569 34 19 34C17.3437 34 16.0009 35.3422 16 36.9983Z"
            fill="white"
            fill-opacity="0.87"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.1 12C18.5633 14.2822 20.581 16 23 16C25.419 16 27.4367 14.2822 27.9 12L41 12C41.5523 12 42 11.5523 42 11C42 10.4477 41.5523 10 41 10L27.9 10C27.4367 7.71776 
                25.419 6 23 6C20.581 6 18.5633 7.71776 18.1 10L7 10C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12L18.1 12ZM23 14C21.3431 14 20 12.6569 20 11C20 9.34314 21.3431 
                8 23 8C24.6569 8 26 9.34314 26 11C26 12.6569 24.6569 14 23 14Z"
            fill="white"
            fill-opacity="0.87"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28.1 25C28.5633 27.2822 30.581 29 33 29C35.419 29 37.4367 27.2822 37.9 25L41 25C41.5523 25 42 24.5523 42 24C42 23.4477 41.5523 23 41 23L37.9 23C37.4367 20.7178 35.419 
                19 33 19C30.581 19 28.5633 20.7178 28.1 23L7 23C6.44772 23 6 23.4477 6 24C6 24.5523 6.44772 25 7 25L28.1 25ZM33 27C31.3431 27 30 25.6569 30 24C30 22.3431 31.3431 21 33 
                21C34.6569 21 36 22.3431 36 24C36 25.6569 34.6569 27 33 27Z"
            fill="white"
            fill-opacity="0.87"
        />
    </svg>
</template>
